import { FormControl, Checkbox, FormHelperText, FormControlLabel } from '@material-ui/core';

function EditFormRegistrationStatusField(props) {
	const { value, onChange } = props.field;
	const { error } = props.fieldState;

	const handleChange = v => {
		if (v) {
			onChange('ACTIVE');
		} else {
			onChange('DISABLED');
		}
	};

	return (
		<FormControl error={error}>
			<FormControlLabel
				control={<Checkbox {...props.field} checked={value === 'ACTIVE'} onChange={e => handleChange(e.target.checked)} inputProps={{ 'aria-label': 'primary checkbox' }} id={props.field.name} />}
				label={props.fieldConfig.text}
			/>
			{error ? <FormHelperText>{error.message}</FormHelperText> : null}
		</FormControl>
	);
}

export default EditFormRegistrationStatusField;
